export const isPlayerPolicy = (player, policyId) => {
  return player?.policy?.id === policyId;
}